import React, {
    useEffect,
    useState
} from "react";

import {
    FaFacebookF,
    FaYoutube,
    FaInstagram,
    FaTelegramPlane,
    FaWhatsapp,
    FaPhoneAlt,
    FaGooglePlay,
    FaApple,
    FaGlobe
} from "react-icons/fa";

import {
    Link
} from "react-router-dom";

import getDomainDetails from "../config/domainDetails";
import API_BASE_URL from "../config/config";


const Footer = () => {

    const [socialLinks, setSocialLinks] = useState(null);

    const [papers, setPapers] = useState([]);

    const [papersLoading, setPapersLoading] = useState(true);


    /*
    |--------------------------------------------------------------------------
    | Fetch Social Links
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const fetchSocialLinks = async () => {

            try {

                const response =
                    await getDomainDetails();

                if (response.success) {

                    setSocialLinks(
                        response.data
                    );

                }

            } catch (error) {

                console.error(
                    "Failed to fetch social links:",
                    error
                );

            }

        };


        fetchSocialLinks();

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Fetch Home Papers
    | Public API - No Login / No Token
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const fetchPapers = async () => {

            try {

                setPapersLoading(true);

                const response = await fetch(
                    `${API_BASE_URL}/home-papers`
                );


                console.log(
                    "Footer Home Papers API Status:",
                    response.status
                );


                const text =
                    await response.text();


                console.log(
                    "Footer Home Papers API Response:",
                    text
                );


                let data;


                try {

                    data =
                        JSON.parse(text);

                } catch (jsonError) {

                    throw new Error(
                        `Server returned invalid JSON. HTTP Status: ${response.status}`
                    );

                }


                if (!response.ok) {

                    throw new Error(
                        data.message ||
                        `Failed to fetch papers (${response.status})`
                    );

                }


                if (data.success) {

                    console.log(
                        "Footer Home Papers:",
                        data.papers
                    );


                    setPapers(
                        Array.isArray(data.papers)
                            ? data.papers.slice(0, 9)
                            : []
                    );

                } else {

                    setPapers([]);

                }

            } catch (error) {

                console.error(
                    "Footer Home Papers API Error:",
                    error
                );

                setPapers([]);

            } finally {

                setPapersLoading(false);

            }

        };


        fetchPapers();

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Premium Social Icon Style
    |--------------------------------------------------------------------------
    */

    const socialIconStyle = {

        width: "42px",

        height: "42px",

        display: "inline-flex",

        alignItems: "center",

        justifyContent: "center",

        borderRadius: "50%",

        color: "#ffffff",

        textDecoration: "none",

        fontSize: "17px",

        background:
            "rgba(255, 255, 255, 0.08)",

        border:
            "1px solid rgba(255, 255, 255, 0.18)",

        boxShadow:
            "0 4px 12px rgba(0, 0, 0, 0.18)",

        transition:
            "all 0.3s ease",

        cursor: "pointer"
    };


    /*
    |--------------------------------------------------------------------------
    | Social Icon Hover
    |--------------------------------------------------------------------------
    */

    const socialHover = (
        event,
        background
    ) => {

        event.currentTarget.style.background =
            background;

        event.currentTarget.style.transform =
            "translateY(-4px) scale(1.08)";

        event.currentTarget.style.boxShadow =
            "0 8px 20px rgba(0, 0, 0, 0.30)";

        event.currentTarget.style.borderColor =
            "rgba(255, 255, 255, 0.45)";

    };


    const socialLeave = (event) => {

        event.currentTarget.style.background =
            "rgba(255, 255, 255, 0.08)";

        event.currentTarget.style.transform =
            "translateY(0) scale(1)";

        event.currentTarget.style.boxShadow =
            "0 4px 12px rgba(0, 0, 0, 0.18)";

        event.currentTarget.style.borderColor =
            "rgba(255, 255, 255, 0.18)";

    };


    return (

        <footer className="footer-section text-light">

            <div className="container py-5">

                <div className="row">


                    {/* =================================================
                        LEFT SECTION
                    ================================================= */}

                    <div className="col-lg-3 col-md-6 mb-4">

                        <div className="d-flex align-items-center mb-3 logo-container">

                            <img
                                src="/assets/logo.png"
                                alt="HomoeoAdda Logo"
                                className="footer-logo"
                            />

                        </div>


                        <p className="footer-text">

                            Start your learning journey today!
                            Access resources anytime, anywhere.

                        </p>


                        {/* APP BUTTONS */}

                        <div className="app-buttons d-flex flex-column">

                            <button
                                type="button"
                                className="btn btn-google mb-2 w-100"
                            >

                                <FaGooglePlay
                                    className="me-2"
                                />

                                Google Play

                            </button>


                            <button
                                type="button"
                                className="btn btn-apple mb-2 w-100"
                            >

                                <FaApple
                                    className="me-2"
                                />

                                App Store

                            </button>


                            <button
                                type="button"
                                className="btn btn-browser w-100"
                            >

                                <FaGlobe
                                    className="me-2"
                                />

                                Web Browser

                            </button>

                        </div>

                    </div>


                    {/* =================================================
                        HOME PAPERS
                    ================================================= */}

                    <div className="col-lg-3 col-md-6 mb-4">

                        <h6 className="footer-title">

                            PAPERS & Category

                        </h6>


                        <ul className="list-unstyled footer-links">

                            {papersLoading ? (

                                <li>

                                    Loading papers...

                                </li>

                            ) : papers.length > 0 ? (

                                papers.map((paper, index) => (

                                    <li
                                        key={
                                            paper.id ||
                                            paper.paper_id ||
                                            index
                                        }
                                    >

                                        {
                                            paper.paper ||
                                            paper.title ||
                                            "Paper"
                                        }

                                    </li>

                                ))

                            ) : (

                                <li>

                                    No papers available.

                                </li>

                            )}

                        </ul>

                    </div>


                    {/* =================================================
                        SOCIAL LINKS
                    ================================================= */}

                    <div className="col-lg-2 col-md-6 mb-4">

                        <h6 className="footer-title">

                            SOCIAL LINKS

                        </h6>


                        <p className="footer-text small">

                            Follow us on social media for
                            latest updates and announcements.

                        </p>


                        {/* =================================================
                            SOCIAL ICONS
                        ================================================= */}

                        <div
                            className="social-icons mt-3 d-flex"
                            style={{
                                gap: "10px",
                                alignItems: "center",
                                flexWrap: "wrap"
                            }}
                        >

                            {/* Facebook */}

                            {socialLinks?.facebook && (

                                <a
                                    href={socialLinks.facebook}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Facebook"
                                    title="Facebook"
                                    style={socialIconStyle}
                                    onMouseEnter={(e) =>
                                        socialHover(
                                            e,
                                            "#1877F2"
                                        )
                                    }
                                    onMouseLeave={socialLeave}
                                >

                                    <FaFacebookF />

                                </a>

                            )}


                            {/* YouTube */}

                            {socialLinks?.youtube && (

                                <a
                                    href={socialLinks.youtube}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="YouTube"
                                    title="YouTube"
                                    style={socialIconStyle}
                                    onMouseEnter={(e) =>
                                        socialHover(
                                            e,
                                            "#FF0000"
                                        )
                                    }
                                    onMouseLeave={socialLeave}
                                >

                                    <FaYoutube />

                                </a>

                            )}


                            {/* Instagram */}

                            {socialLinks?.instagram && (

                                <a
                                    href={socialLinks.instagram}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Instagram"
                                    title="Instagram"
                                    style={socialIconStyle}
                                    onMouseEnter={(e) =>
                                        socialHover(
                                            e,
                                            "linear-gradient(135deg, #833AB4, #FD1D1D, #FCB045)"
                                        )
                                    }
                                    onMouseLeave={socialLeave}
                                >

                                    <FaInstagram />

                                </a>

                            )}


                            {/* Telegram */}

                            {socialLinks?.telegram && (

                                <a
                                    href={socialLinks.telegram}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Telegram"
                                    title="Telegram"
                                    style={socialIconStyle}
                                    onMouseEnter={(e) =>
                                        socialHover(
                                            e,
                                            "#229ED9"
                                        )
                                    }
                                    onMouseLeave={socialLeave}
                                >

                                    <FaTelegramPlane />

                                </a>

                            )}


                            {/* WhatsApp */}

                            {socialLinks?.whatsapp && (

                                <a
                                    href={`https://wa.me/${String(
                                        socialLinks.whatsapp
                                    ).replace(/\D/g, "")}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="WhatsApp"
                                    title="WhatsApp"
                                    style={socialIconStyle}
                                    onMouseEnter={(e) =>
                                        socialHover(
                                            e,
                                            "#25D366"
                                        )
                                    }
                                    onMouseLeave={socialLeave}
                                >

                                    <FaWhatsapp />

                                </a>

                            )}

                        </div>

                    </div>


                    {/* =================================================
                        OTHER LINKS
                    ================================================= */}

                    <div className="col-lg-2 col-md-6 mb-4">

                        <h6 className="footer-title">

                            OTHER LINKS

                        </h6>


                        <ul className="list-unstyled footer-links">

                            <li>

                                <Link
                                    to="/contact"
                                    className="text-decoration-none text-white"
                                >

                                    Contact Us

                                </Link>

                            </li>


                            <li>

                                <Link
                                    to="/privacy-policy"
                                    className="text-decoration-none text-white"
                                >

                                    Privacy Policy

                                </Link>

                            </li>


                            <li>

                                <Link
                                    to="/refund-policy"
                                    className="text-decoration-none text-white"
                                >

                                    Refund Policy

                                </Link>

                            </li>


                            <li>

                                <Link
                                    to="/terms-and-conditions"
                                    className="text-decoration-none text-white"
                                >

                                    Terms & Conditions

                                </Link>

                            </li>

                        </ul>

                    </div>


                    {/* =================================================
                        DOWNLOAD APP
                    ================================================= */}

                    <div className="col-lg-2 col-md-12">

                        <h6 className="footer-title">

                            DOWNLOAD THE APP

                        </h6>


                        <p className="footer-text small">

                            Download the HomoeoAdda app for
                            Android and iOS.

                        </p>


                        <div style={{ marginTop: "15px" }}>


                            {/* =================================================
                                ANDROID APP
                            ================================================= */}

                            <a
                                href="/apps/Homoeoadda.apk"
                                download="Homoeoadda.apk"
                                className="d-flex align-items-center text-decoration-none"
                                style={{
                                    width: "100%",
                                    padding: "10px 12px",
                                    marginBottom: "12px",
                                    border: "1px solid rgba(255,255,255,0.25)",
                                    borderRadius: "8px",
                                    background: "rgba(255,255,255,0.08)",
                                    color: "#ffffff",
                                    transition: "0.3s ease"
                                }}
                            >

                                <FaGooglePlay
                                    style={{
                                        fontSize: "28px",
                                        marginRight: "10px",
                                        flexShrink: 0
                                    }}
                                />


                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        lineHeight: "1.2"
                                    }}
                                >

                                    <small
                                        style={{
                                            fontSize: "8px",
                                            fontWeight: "500",
                                            letterSpacing: "0.5px",
                                            color: "rgba(255,255,255,0.75)"
                                        }}
                                    >

                                        DOWNLOAD FOR

                                    </small>


                                    <strong
                                        style={{
                                            fontSize: "15px",
                                            fontWeight: "600",
                                            color: "#ffffff"
                                        }}
                                    >

                                        Android

                                    </strong>

                                </div>

                            </a>


                            {/* =================================================
                                iOS APP
                            ================================================= */}

                            <a
                                href="/apps/homoeoadda-ios.ipa"
                                download="homoeoadda-ios.ipa"
                                className="d-flex align-items-center text-decoration-none"
                                style={{
                                    width: "100%",
                                    padding: "10px 12px",
                                    border: "1px solid rgba(255,255,255,0.25)",
                                    borderRadius: "8px",
                                    background: "rgba(255,255,255,0.08)",
                                    color: "#ffffff",
                                    transition: "0.3s ease"
                                }}
                            >

                                <FaApple
                                    style={{
                                        fontSize: "30px",
                                        marginRight: "10px",
                                        flexShrink: 0
                                    }}
                                />


                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        lineHeight: "1.2"
                                    }}
                                >

                                    <small
                                        style={{
                                            fontSize: "8px",
                                            fontWeight: "500",
                                            letterSpacing: "0.5px",
                                            color: "rgba(255,255,255,0.75)"
                                        }}
                                    >

                                        DOWNLOAD FOR

                                    </small>


                                    <strong
                                        style={{
                                            fontSize: "15px",
                                            fontWeight: "600",
                                            color: "#ffffff"
                                        }}
                                    >

                                        iOS

                                    </strong>

                                </div>

                            </a>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                FOOTER BOTTOM
            ================================================= */}

            <div className="footer-bottom text-center py-3">

                <div>

                    &copy; {new Date().getFullYear()} HomoeoAdda.
                    All rights reserved.

                </div>


                

            </div>

        </footer>

    );

};


export default Footer;
